import { app } from '../../app.module'
app
  // カテゴリ情報管理モーダル
  .directive('editCategoryModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog, $filter, EditCategoryService, DialogService) => {
        $scope.createCategoryFlg = false
        $scope.query = {
          limit: 10,
          page: 1,
          options: [5, 10, 15],
        }
        $scope.type = 'edit'

        /**
         * changeCreateButton 新規作成のボタン状態を変更
         * @return {void}
         */
        $scope.changeCreateButton = function (createCategoryFlg) {
          $scope.createCategoryFlg = !createCategoryFlg
        }

        // ソートのイベント
        $scope.onReorder = function (order) {
          $scope.brandCategories = $filter('orderBy')($scope.brandCategories, order)
          // ページングを初期化
          $scope.query.page = 1
        }
        /**
         * getBrandCategories 大カテゴリ一覧の取得
         * @return {void}
         */
        function getBrandCategories() {
          // ロード中フラグ
          $scope.isLoading = true

          EditCategoryService.EditCategory.getBrandCategories().then((brandCategories) => {
            $scope.brandCategories = $filter('orderBy')(brandCategories, '-sortNoBefore')
            $scope.countBrandCategories = brandCategories.length
          })
        }

        getBrandCategories()

        /**
         * saveBrandCategory 大カテゴリの保存(追加・編集)
         * @return {void}
         */
        $scope.saveBrandCategory = function (saveType, sortNo, categoryName, categoryBefore) {
          const categoryInfo = {
            saveType: saveType,
            sortNo: sortNo,
            categoryName: categoryName,
            categoryBefore: categoryBefore,
          }

          EditCategoryService.EditCategory.saveBrandCategory(categoryInfo).then((result) => {
            // 保存成功時
            if (result.error === false) {
              // 追加の場合、大カテゴリ一覧に新しいレコードを追加
              if (saveType === 'categoryAdd') {
                $scope.brandCategories.unshift({
                  categoryName: categoryName,
                  categoryBefore: categoryName,
                  countSubCategories: 0,
                  sortNo: sortNo,
                  sortNoBefore: sortNo,
                })
                $scope.countBrandCategories = $scope.countBrandCategories + 1
                $scope.createCategoryFlg = false
              } else {
                const editCategory = $filter('filter')($scope.brandCategories, {
                  categoryName: categoryName,
                })
                editCategory[0].categoryBefore = categoryName
                editCategory[0].sortNoBefore = sortNo
              }

              // カテゴリ情報が変更されたことを親スコープへ通知
              $scope.$emit('changeCategoriesList')
            } else {
              // 失敗した場合 AND 大カテゴリの編集の場合、大カテゴリとソート番号をリセット
              if (saveType === 'categoryEdit') {
                const editCategory = $filter('filter')($scope.brandCategories, {
                  categoryName: categoryName,
                })
                editCategory[0].categoryName = editCategory[0].categoryBefore
                editCategory[0].sortNo = editCategory[0].sortNoBefore
              }

              let errorMessage = '大カテゴリの保存に失敗しました。'

              if (result.data === 'duplicate') {
                errorMessage = '既に存在する大カテゴリです。'
              }
              // 保存失敗時、toastを表示する
              DialogService.showToast(errorMessage, 'error-toast')
            }
          })
        }

        /**
         * deleteCategory 大カテゴリの削除
         * @return {void}
         */
        $scope.deleteCategory = function (category) {
          // 確認メッセージ
          if (confirm('大カテゴリが削除されます。本当に削除してよろしいですか?')) {
            EditCategoryService.EditCategory.deleteBrandCategory(category.categoryName).then(
              (result) => {
                // 削除成功の場合
                if (result !== null && result !== undefined) {
                  // 大カテゴリ一覧に削除された大カテゴリを表示しない
                  category.hide = true
                  // 大カテゴリ数をアップデート
                  $scope.countBrandCategories = $scope.countBrandCategories - 1
                  // カテゴリ情報が変更されたことを親スコープへ通知
                  $scope.$emit('changeCategoriesList')
                }
              }
            )
          }
        }

        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
